import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

function AdminHeroBanner() {

    const [banners, setBanners] = useState([]);

    const [showForm, setShowForm] = useState(false);
const [editingId, setEditingId] = useState(null);
const [selectedImage, setSelectedImage] = useState(null);
    const [form, setForm] = useState({
        title: "",
        subtitle: "",
        button_text: "",
        button_link: "",
        image: "",
        status: "Active"
    });

    useEffect(() => {
        loadBanners();
    }, []);

    // ===========================
    // LOAD BANNERS
    // ===========================

    const loadBanners = () => {

        axios.get(`${API_URL}/admin/hero-banners`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        })

        .then((res) => {

            setBanners(res.data);

        })

        .catch((err) => {

            console.log(err);

        });

    };
const uploadImage = async () => {

    if (!selectedImage) return form.image;

    const data = new FormData();

    data.append("image", selectedImage);

    const res = await axios.post(
        `${API_URL}/upload`,
        data,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return res.data.image;

};
const saveBanner = async () => {

    try {

        const image = await uploadImage();

        const banner = {
            ...form,
            image
        };

        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        };

        if (editingId) {

            await axios.put(
                `${API_URL}/admin/hero-banners/${editingId}`,
                banner,
                config
            );

            alert("Banner Updated");

        } else {

            await axios.post(
                `${API_URL}/admin/hero-banners`,
                banner,
                config
            );

            alert("Banner Added");

        }

        setEditingId(null);

        setShowForm(false);

        setSelectedImage(null);

        setForm({
            title: "",
            subtitle: "",
            button_text: "",
            button_link: "",
            image: "",
            status: "Active"
        });

        loadBanners();

    }

    catch (err) {

        console.log(err);

    }

};
const editBanner = (banner) => {

    setEditingId(banner.id);

    setForm({
        title: banner.title,
        subtitle: banner.subtitle,
        button_text: banner.button_text,
        button_link: banner.button_link,
        image: banner.image,
        status: banner.status
    });

    setShowForm(true);

};
const deleteBanner = async (id) => {

    if (!window.confirm("Delete Banner?"))
        return;

    await axios.delete(

        `${API_URL}/admin/hero-banners/${id}`,

        {
            headers: {
                Authorization:
                    `Bearer ${localStorage.getItem("token")}`
            }
        }

    );

    loadBanners();

};
    // ===========================
    // INPUT CHANGE
    // ===========================

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value

        });

    };

    return (

        <div className="admin-layout">

            <AdminSidebar />

            <div className="admin-content">

                <h1>Hero Banner Management</h1>

                <button
                    className="edit-btn"
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? "Close Form" : "Add New Banner"}
                </button>

                {
                    showForm && (

                        <div className="edit-product-box">

                            <h2>Add Hero Banner</h2>

                            <input
                                type="text"
                                name="title"
                                placeholder="Banner Title"
                                value={form.title}
                                onChange={handleChange}
                            />

                            <textarea
                                name="subtitle"
                                placeholder="Banner Subtitle"
                                value={form.subtitle}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="button_text"
                                placeholder="Button Text"
                                value={form.button_text}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="button_link"
                                placeholder="/shop"
                                value={form.button_link}
                                onChange={handleChange}
                            />

                           <input
type="file"
accept="image/*"
onChange={(e)=>setSelectedImage(e.target.files[0])}
/>

                            <select
                                name="status"
                                value={form.status}
                                onChange={handleChange}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>

                            <button
className="edit-btn"
onClick={saveBanner}
>
{editingId ? "Update Banner" : "Save Banner"}
</button>

                        </div>

                    )
                }

                <table className="admin-table">

                    <thead>

                        <tr>

                            <th>ID</th>

                            <th>Image</th>

                            <th>Title</th>

                            <th>Status</th>

                            <th>Action</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            banners.map((banner) => (

                                <tr key={banner.id}>

                                    <td>{banner.id}</td>

                                    <td>

                                        <img
                                            src={`http://localhost:5000${banner.image}`}
                                            alt={banner.title}
                                            width="120"
                                        />

                                    </td>

                                    <td>{banner.title}</td>

                                    <td>{banner.status}</td>

                                    <td>

                                       <button
className="edit-btn"
onClick={() => editBanner(banner)}
>
Edit
</button>

                                        <button
className="delete-btn"
onClick={() => deleteBanner(banner.id)}
>
Delete
</button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}

export default AdminHeroBanner;